export default "__VITE_ASSET__DHkj7f3C__"